import { render } from "./VideoGridItem.vue?vue&type=template&id=ab3115d4&scoped=true"
import script from "./VideoGridItem.vue?vue&type=script&lang=js"
export * from "./VideoGridItem.vue?vue&type=script&lang=js"

import "./VideoGridItem.vue?vue&type=style&index=0&id=ab3115d4&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3115d4"]])

export default __exports__